<div class="w-full font-normal text-xs" data-testid="cabinet-documents-modal">
  <div
    [class]="'flex-row p-3 bg-kz-layout-featured ' + (hasInsuranceLines() ? 'hidden @xl/dyn-modal-body:flex' : 'flex')"
  >
    <div class="px-2 w-25">{{ 'Type' | translate }}</div>
    <div class="px-2 flex-1">{{ 'Description' | translate }}</div>
    <div class="px-2 w-20">{{ 'Action' | translate }}</div>
  </div>
  @for (document of documents(); track $index) {
    @if (document.insurance) {
      <app-reservation-insurance-row
        [document]="document"
        [reservationId]="reservation()?.id"
        [reservationNumber]="reservation()?.number"
      />
    } @else {
      <div
        class="flex flex-row p-3 border-b-kz-light-blue-400 border-b"
        data-qa="reservation-docs-row"
        [attr.data-testid]="'reservation-docs-row-' + testIdSuffix(document)"
      >
        <div class="px-2 w-25 flex flex-row items-center" data-qa="reservation-docs-type">
          {{ typeLabel(document) | translate }}
        </div>
        <div class="px-2 flex-1 flex items-center" data-qa="reservation-docs-description">
          @for (description of document.descriptions ?? []; track $index) {
            {{ description | translate }}
          }
        </div>
        <div class="px-2 w-25 flex items-center">
          <button
            type="button"
            color="primary"
            mat-stroked-button
            class="border-kz-primary! rounded-none! text-xs! tracking-normal!"
            loadingStyleClass="scale-40 left-0!"
            data-qa="reservation-docs-download-button"
            [attr.data-testid]="'reservation-docs-download-button-' + testIdSuffix(document)"
            [disabled]="!canDownload() || isDownloading()"
            [loading]="downloadingUrl() === document.url"
            (click)="onDownloadDocument(document)"
          >
            {{ 'Download' | translate }}
          </button>
        </div>
      </div>
    }
  }
</div>
